<template>
  <div>
    <div v-if="isLoading">กำลังโหลดข้อมูล...</div>
    <ResultForm v-else :data="data" :is-new="false" @save="save"></ResultForm>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

import ResultForm from "./ResultForm.vue"

import moment from "moment"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      resultData: null,
      isLoading: false,
      lotto: {
        lotto_date: moment().format("YYYY-MM-DD"),
        start_spin: '',
        show_result: '',
        results: {
          digit5: '',
          // digit4: '',
          // digit3: '',
          // digit2_top: '',
          // digit2_bottom: ''
        }
      },
    }
  },
  computed: {
    data() {
      return this.lotto
    },
    digit5() {
      return this.lotto.results.digit5
    }
  },
  watch: {
    // digit5(val) {
    //   if (val) {
    //     let res = val.split("")
    //     if (res.length === 5) {
    //       this.lotto.results.digit4 = `${res[1]}${res[2]}${res[3]}${res[4]}`
    //       this.lotto.results.digit3 = `${res[2]}${res[3]}${res[4]}`
    //       this.lotto.results.digit2_top = `${res[3]}${res[4]}`
    //       this.lotto.results.digit1 = `${res[4]}`
    //       this.lotto.results.digit2_bottom = `${res[0]}${res[1]}`
    //     } else {
    //       this.lotto.results.digit4 = ''
    //       this.lotto.results.digit3 = ''
    //       this.lotto.results.digit2_top = ''
    //       this.lotto.results.digit1 = ''
    //       this.lotto.results.digit2_bottom = ''
    //     }
    //   } else {
    //     this.lotto.results.digit4 = ''
    //     this.lotto.results.digit3 = ''
    //     this.lotto.results.digit2_top = ''
    //     this.lotto.results.digit1 = ''
    //     this.lotto.results.digit2_bottom = ''
    //   }
    // }
  },
  methods: {
    loadResult() {
      this.isLoading = true
      LottoService.getResult(this.$route.params.resultId)
      .then((response) => {
        if (response.status === 'success') {
          this.resultData = response.data
          this.lotto.lotto_date = this.resultData.lotto_date
          this.lotto.start_spin = this.resultData.start_spin
          this.lotto.show_result = this.resultData.show_result
          this.lotto.results = this.resultData.results
          this.isLoading = false
        } else {
          this.$router.push({ name: 'AdminResults' })
        }
      })
    },
    save(data) {
      LottoService.updateResult(this.$route.params.resultId, data).then((response) => {
        console.log(response)
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'AdminResults' })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {
    this.loadResult()
  }
}

</script>
